// AI - Customer Logos: when the row is wider than the screen, keep it scrolled to the middle
function center(el) {
  el.scrollLeft = (el.scrollWidth - el.clientWidth) / 2
}

export default function initAiLogos() {
  const rows = document.querySelectorAll('.js-ai-logos')
  if (!rows.length) return

  const centerAll = () => rows.forEach(center)

  centerAll()
  // Logos may finish loading later and change the row width
  window.addEventListener('load', centerAll)

  // Re-center on resize, only when the width changes
  // (mobile browsers fire resize on scroll when the address bar hides)
  let width = window.innerWidth
  let frame = null
  window.addEventListener('resize', () => {
    if (window.innerWidth === width) return
    width = window.innerWidth
    cancelAnimationFrame(frame)
    frame = requestAnimationFrame(centerAll)
  })
}
